import * as React from 'react';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import styled from '@emotion/styled';
import { cloneDeep } from 'lodash';
import Button from '@mui/material/Button';
import useFetch from '../../../../hooks/useFetch';
import { FilterUploadHistory, HistoryItem } from '../../../../interfaces/interfaces';
import TableHeadUploadHistory from './TableHeadUploadHistory/TableHeadUploadHistory';
import TableBodyUploadHistory from './TableBodyUploadHistory';
import TablePaginationCustom from './TablePaginationCustom';

const initFilterUploadHistory = {
  uploadedOn: '',
  uploadedBy: '',
  fileType: '',
  fileContent: '',
  fileSource: '',
  version: '',
  fileLastUpdated: '',
  fileName: '',
  uploadStatus: '',
};

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 1rem;
`;

const UploadHistory = () => {
  const [tablePage, setTablePage] = React.useState(1);
  const [amountPages, setAmountPage] = React.useState(0);
  const [filterData, setFilterData] = React.useReducer(
    (filterProps: FilterUploadHistory, newProp: Partial<FilterUploadHistory>) => ({ ...filterProps, ...newProp }),
    initFilterUploadHistory
  );
  const [cleanInputs, setCleanInputs] = React.useState({});

  const { data, loading, error } = useFetch<HistoryItem[]>(`${process.env.REACT_APP_URL_HOST}/admin/v1/imports`);

  React.useEffect(() => {
    return () => setFilterData(cloneDeep(initFilterUploadHistory));
  }, [setFilterData]);

  const handleInputs = React.useCallback(() => setCleanInputs({}), [setCleanInputs]);
  if (error) return <pre>{JSON.stringify(error, null, 2)}</pre>;
  return (
    <>
      <TableContainer>
        <StyledContainer>
          <Button variant="contained" onClick={handleInputs}>
            Clear Filter
          </Button>
        </StyledContainer>
        <Table sx={{ minWidth: 900, tableLayout: 'fixed' }}>
          <TableHeadUploadHistory setFilterData={setFilterData} cleanInputs={cleanInputs} />
          <TableBodyUploadHistory
            loading={loading}
            tablePage={tablePage}
            filterData={filterData}
            data={data}
            setAmountPage={setAmountPage}
            setTablePage={setTablePage}
          />
        </Table>
      </TableContainer>
      <TablePaginationCustom tablePage={tablePage} setTablePage={setTablePage} amountPages={amountPages} />
    </>
  );
};

export default UploadHistory;
